module.exports = __webpack_public_path__ + "img/default-grasshopper.b6139116.svg";